// Скелетон для навигационной цепочки (breadcrumbs)
import React from "react";
import { Skeleton } from "../Skeleton/Skeleton";

// Icons
import ArrowRightIcon from "../../icons/ArrowRightIcon";

export function BreadcrumbsSkeleton() {
  return (
    <div className="tbk-overflow-hidden">
      <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-8">
        <div className="tb-slider tbk-mb-3 tbk-mt-3 tbk-flex tbk-flex-nowrap tbk-items-center">
          {/* Первый элемент */}
          <Skeleton className="tbk-mx-1 tbk-h-3 tbk-w-32 tbk-rounded-r-lg tbk-rounded-bl-lg tbk-border tbk-border-blue-grey-light" />
          {/* Иконка */}
          <ArrowRightIcon className="tbk-text-blue-grey-light" />
          {/* Второй элемент */}
          <Skeleton className="tbk-mx-1 tbk-h-3 tbk-w-36 tbk-rounded-r-lg tbk-rounded-bl-lg tbk-border tbk-border-blue-grey-light" />
          {/* Иконка */}

          <ArrowRightIcon className="tbk-text-blue-grey-light" />
          {/* Активный элемент */}

          <Skeleton className="tbk-mx-1 tbk-h-3 tbk-w-24 tbk-rounded-lg tbk-border tbk-border-blue-grey-light tbk-bg-blue-grey-light" />
        </div>
      </div>
    </div>
  );
}
